export default "__VITE_ASSET___BmKFZGY__"